module.exports = __webpack_public_path__ + "img/phone.34c7bd25.svg";